import React, { lazy } from 'react';
import { Loadable } from 'components';
import RoleGuard from './RoleGuard';
import { MainLayoutWithProvider } from 'components';

const Registration = Loadable(lazy(() => import('pages/Registration')));
const CertificationDetails = Loadable(lazy(() => import('pages/CertificateDetails')));
const Overview = Loadable(lazy(() => import('pages/Overview/index')));
const DevDashboard = Loadable(lazy(() => import('pages/Devdashboard')));
const MentorDashboard = Loadable(lazy(() => import('pages/MentorDashboard/index')));
const NotFound = Loadable(lazy(() => import('pages/NotFound')));
const ChangePassword = Loadable(lazy(() => import('pages/ChangePassword')));
const AdminCertifications = Loadable(lazy(() => import('pages/Admin/Certifications')));
const Chapters = Loadable(lazy(() => import('pages/Admin/Chapters')));
const Modules = Loadable(lazy(() => import('pages/Admin/Modules')));
const Dashboard = Loadable(lazy(() => import('pages/Admin/Dashboard')));
const AddCertificate = Loadable(lazy(() => import('pages/Admin/AddCertificate')));
const AddModule = Loadable(lazy(() => import('pages/Admin/AddModule')));
const AddChapters = Loadable(lazy(() => import('pages/Admin/AddChapter')));
const Registrations = Loadable(lazy(() => import('pages/Admin/Registrations')));
const MetaInfo = Loadable(lazy(() => import('pages/Admin/MetaInfo')));
const Profile = Loadable(lazy(() => import('pages/Profile')));
const NotAuthorised = Loadable(lazy(() => import('pages/NotAuthorised')));
const UserCertifications = Loadable(lazy(() => import('pages/Admin/UserCertifications')));
const MentorAvailabilty = Loadable(lazy(() => import('pages/MentorAvailabilty')));
const DevBookSession = Loadable(lazy(() => import('pages/DevBookSession')));
const VerifyCertifiCate = Loadable(lazy(() => import('pages/VerifyCertifiCate')));
const PlayChapter = Loadable(lazy(() => import('pages/PlayChapter')));

// Walkthrough (formerly HowTo)
const Walkthroughs = Loadable(lazy(() => import('pages/Admin/HowTos')));
const AddWalkthrough = Loadable(lazy(() => import('pages/Admin/AddHowto')));
const Walkthrough = Loadable(lazy(() => import('pages/HowTo')));

// ==============================|| MAIN ROUTES ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayoutWithProvider />,
  children: [
    { path: '/', element: <Registration /> },
    { path: 'Registration', element: <Registration /> },
    { path: `Certificate`, element: <CertificationDetails /> },
    { path: "Overview/:mode?", element: <Overview /> },
    { path: 'ChangePassword', element: <ChangePassword /> },
    { path: 'Profile', element: <Profile /> },
    { path: 'VerifyCertifiCate', element: <VerifyCertifiCate /> },
    { path: 'Watch', element: <PlayChapter /> },
    { path: 'Walkthrough', element: <Walkthrough /> },

    

    // Guarded routes
    {
      element: <RoleGuard allowedRoles={['DEVELOPER']} />, // wrapper for dev dashboard
      children: [
        { path: `DevDashboard`, element: <DevDashboard /> }
      ]
    },
    {
      element: <RoleGuard allowedRoles={['DEVELOPER']} />, // wrapper for dev dashboard
      children: [
        { path: `BookSession`, element: <DevBookSession /> }
      ]
    },
    {
      element: <RoleGuard allowedRoles={['MENTOR']} />, // wrapper for mentor dashboard
      children: [
        { path: `MentorDashboard`, element: <MentorDashboard /> }
      ]
    },
    {
      element: <RoleGuard allowedRoles={['MENTOR']} />, // wrapper for mentor dashboard
      children: [
        { path: `MentorAvailabilty`, element: <MentorAvailabilty /> }
      ]
    },
    {
      element: <RoleGuard allowedRoles={['ADMIN']} />, // wrapper for admin dashboard
      children: [
        { path: `Certifications`, element: (<AdminCertifications />) },
        { path: `Chapters`, element: (<Chapters />) },
        { path: `Modules`, element: (<Modules />) },
        { path: `Dashboard`, element: (<Dashboard />) },
        { path: `CreateCertificate`, element: (<AddCertificate />) },
        { path: `UpdateCertificate`, element: (<AddCertificate />) },
        { path: `CreatedModule`, element: (<AddModule />) },
        { path: `UpdateModule`, element: (<AddModule />) },
        { path: `CreateChapter`, element: (<AddChapters />) },
        { path: `UpdateChapter`, element: (<AddChapters />) },
        { path: `Registrations`, element: (<Registrations />) },
        { path: `MetaData`, element: (<MetaInfo />) },
        { path: `UserCertifications`, element: (<UserCertifications />) },
        // Admin Walkthroughs
        { path: `Walkthroughs`, element: <Walkthroughs /> },
        { path: `CreateWalkthrough`, element: <AddWalkthrough /> },
        { path: `UpdateWalkthrough`, element: <AddWalkthrough /> }
      ]
    },
    { path: `NotFound`, element: <NotFound /> },
    { path: `NotAuthorised`, element: <NotAuthorised /> },
    { path: '*', element: <NotFound /> }
  ]
};

export default MainRoutes;
